export default "__VITE_ASSET__DlByc983__"